<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" epub:type="pagebreak" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" epub:type="pagebreak" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf"><a class="xref" href="#/chielliottdemocracy0007#ch01"><span class="sm">CHAPTER</span> <span class="sm">1.</span>  The Demands of Democratic Citizenship</a></p>
<p class="tocpt"><a class="xref" href="#/chielliottdemocracy0008#pt01"><span class="sm">PART</span> <span class="sm">I:</span>  How Much Democratic Citizenship?</a></p>
<p class="toc"><a class="xref" href="#/chielliottdemocracy0009#ch02"><span class="sm">CHAPTER</span> <span class="sm">2.</span>  Democracy’s Floor: The Case against Apathy</a></p>
<p class="toc"><a class="xref" href="#/chielliottdemocracy0010#ch03"><span class="sm">CHAPTER</span> <span class="sm">3.</span>  When Does Democracy Ask Too Much? Realism and the Paradox of Empowerment</a></p>
<p class="toc"><a class="xref" href="#/chielliottdemocracy0011#ch04"><span class="sm">CHAPTER</span> <span class="sm">4.</span>  The Citizen Minimum: Inclusion and Stand-By Citizenship</a></p>
<p class="tocpt"><a class="xref" href="#/chielliottdemocracy0012#pt02"><span class="sm">PART</span> <span class="sm">II:</span>  Democratic Institutions for Busy People</a></p>
<p class="toc"><a class="xref" href="#/chielliottdemocracy0013#ch05"><span class="sm">CHAPTER</span> <span class="sm">5.</span>  How to Democratize Elections: Annual Elections and Mandatory Voting</a></p>
<p class="toc"><a class="xref" href="#/chielliottdemocracy0014#ch06"><span class="sm">CHAPTER</span> <span class="sm">6.</span>  Engines of Inclusion: Political Parties in Competition</a></p>
<p class="toc"><a class="xref" href="#/chielliottdemocracy0015#ch07"><span class="sm">CHAPTER</span> <span class="sm">7.</span>  Putting Deliberation and Sortition in Their Place</a></p>
<p class="tocf"><a class="xref" href="#/chielliottdemocracy0016#conc"><span class="sm">CONCLUSION:</span> Too Much Democracy? 203</a></p>
<p class="tocbmf"><a class="xref" href="#/chielliottdemocracy0017#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chielliottdemocracy0018#app">Appendix</a></p>
<p class="tocbm"><a class="xref" href="#/chielliottdemocracy0019#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chielliottdemocracy0020#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/chielliottdemocracy0021#fn_notes">Footnotes</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-elliott-democracy-0006.vue?269ce5dd